import {useNavigate, useSearchParams} from "react-router-dom";
import {routeSelector, useGetRouteQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {RouteProfile} from "../../components/profile/RouteProfile/RouteProfile";

type Props = {
  id?: string;
}

export const RouteProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.route", "Route") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <RouteProfilePage id={id}/>;
};

export const RouteProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const selectRoute = useMemo(() => {
    return routeSelector()
  }, []);

  const {route, isFetching, error} = useGetRouteQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      route: selectRoute(result),
      isFetching: result.isFetching,
      error: result.error,
    })
  });

  return (
    <EntityProfilePage
      permissions={["route_view"]}
      entity={route}
      isLoading={isFetching}
      error={error}
      onAccess={setAccess}>
      {(entity) => (
        <RouteProfile route={entity}/>
      )}
    </EntityProfilePage>
  )
};
